import { Action } from '@ngrx/store';
import {PlanListParams} from '../plan-list.model';

export enum PlanListFilerActionTypes {
  LoadPlanListFilers = '[PlanListFiler] Load PlanListFilers',
}

export class LoadPlanListFilers implements Action {
  readonly type = PlanListFilerActionTypes.LoadPlanListFilers;
  constructor(public payload: PlanListParams) {}
}


export type PlanListFilerActions = LoadPlanListFilers;
